class Cookie {

	constructor(cookie) {
		this.name = cookie;
		this.value = this.get();
	}

	get() {
		let name = this.name + "=";
		let decodedCookie = decodeURIComponent(document.cookie);
		let ca = decodedCookie.split(';');

		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) == ' ') {
				c = c.substring(1);
			}
			if (c.indexOf(name) == 0) {
				return c.substring(name.length, c.length);
			}
		}
		return null;
	}

	set(value, days = 1) {
		var date = new Date();
		date.setDate(date.getDate() + days);

		document.cookie = this.name + '=' + value + '; expires = ' + date +"; path=/";
	}

	delete() {
		document.cookie = this.name + "= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
	}
}

export default Cookie;